// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d57945cc","366":"c37065c3","474":"7b31cd7c","719":"176bbc20","775":"46416aa9","786":"bb3a7270"}[chunkId] + ".chunk.js";
};